import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { NpsSubmitPayload, NpsTriggerPayload } from "@/types/nps";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const postNpsTrigger = async (payload: NpsTriggerPayload) => {
  try {
    const { data } = await axiosInstance.post("/v1/nps/trigger", payload);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postNpsResponse = async (
  npsId: string,
  payload: NpsSubmitPayload
) => {
  try {
    const { data } = await axiosInstance.post(
      `/v1/nps/response/${npsId}`,
      payload
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
